import React, { useEffect, useState, useRef } from "react";
import useHttp from '../../../../hook/use-http';
import Chart from 'react-apexcharts'
import stats from 'wink-statistics';
import NoData from '../NoData';
import ChartLoader from '../ChartLoader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarCheckFill } from "react-icons/bs";
import moment from 'moment';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import WaterMark from "../../DashboardMain/WaterMark";

function TorqueBox({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const [selectedD, setselectedD] = useState(new Date());
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({});

  const dateselection = useRef();
  let edate
  const appyDataDate = (data) => {
    const res_result = data;
    const setevnetdate = res_result[0].max_eventdate.value_as_string
    edate = moment.parseZone(setevnetdate)
    setselectedD(moment(new Date(edate)).toDate())
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter, selectedDate: edate } }, appyData)
  }

  const appyData = (data) => {
    const res_result = data.result;
    const date_display = data.date_display;

    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        type: 'boxPlot',
        data: []
      }]
      let y_data_set = [];
      temp_result.map(x => {
        let temp_data = x._source.mcu_motor_torque;
        y_data_set.push(parseFloat((temp_data)));
      })
      y_data_set = y_data_set.sort(function (a, b) { return a - b });
      let boxplot = stats.data.boxplot;
      let data_set = boxplot(y_data_set);
      res_result_final[0].data.push({ x: "Ace Ev", y: [data_set.min.toFixed(2), data_set.q1.toFixed(2), data_set.median.toFixed(2), data_set.q3.toFixed(2), data_set.max.toFixed(2)] })
      setChartData((prestate) => res_result_final);
      setselectedD(moment(new Date(date_display)).toDate());

      window.dispatchEvent(new Event('resize'));
    } else {
      setselectedD(moment(new Date(date_display)).toDate());
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }

  const chageDateSelection = () => {
    dateselection.current.setFocus();
  }

  const options = {
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -100,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350
    },
    yaxis: {
      show: true,
      title: {
        text: "Motor Torque",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  const options_popup = {
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -60,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350
    },
    yaxis: {
      show: true,
      title: {
        text: "Motor Torque",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "drivesecondpagecharts/eventdate", body: { filterdata: { "VIN_NUM": gloablfilter.vin_num } } }, appyDataDate)
  }, [gloablfilter])

  const chnageSelection = (date) => {
    setselectedD(date);
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter, selectedDate: date } }, appyData)
  }

  return (
    <>
      <div className="modal fade" id="torqueBoxsecond" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Torque distribution</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options_popup} series={chartdata} type="boxPlot" height={300} />)}
            </div>
          </div>
        </div>
      </div>

      <div className="v-title chartbox">
        <div className="titlebg " style={{ margin: "0px" }}>Torque distribution <strong onClick={chageDateSelection} style={{ float: "right" }}> <BsFillCalendarCheckFill /> </strong>
          <strong id="oldpz" style={{ float: "right", cursor: "pointer", marginRight: "5px" }} data-bs-toggle="modal" data-bs-target={"#torqueBoxsecond"} > <BsZoomIn /> </strong>
          <DatePicker id="selectdate_box" ref={dateselection} selected={selectedD} onChange={chnageSelection} dateFormat="dd-MM-yyyy" />
        </div>
        <div className="chartHGT">
          <WaterMark />
          {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options} series={chartdata} type="boxPlot" height={160} />)}
        </div>
        <div style={{ bottom: "10px", position: "absolute" }}><small style={{ fontSize: "9px", fontWeight: 800 }}>Global filters don't affect on this chart except Vin filter</small></div>
      </div>
    </>
  );
}

export default TorqueBox;